import { LoadConfigService } from '../services/load-config.service';
import { HttpClient } from '@angular/common/http';
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { UtilsService } from '../services/utils.service';
import { ReloadingService } from '../services/reloading.service';

// check if we can load new config

const loadConfigService: LoadConfigService = new LoadConfigService(
  new UtilsService(),
  new ReloadingService()
);

let opacity: number = loadConfigService.getFadeOutOpacity();
let fadeOutTime: number = loadConfigService.getFadeOutTime();

export const FadeOutAnimation = [
  trigger('fadeOut', [
    state('*', style({ opacity: opacity })),
    transition(':enter', [
      style({ opacity: 1 }),
      animate(`${fadeOutTime}ms linear`, style({ opacity: opacity })),
    ]),
  ]),
];
